import tw, { styled } from 'twin.macro'

export const KeyWrapper = styled.div`
  ${tw`flex flex-col space-y-2 mt-10 mb-20`}

  div {
    ${tw`flex space-x-4`}
  }
`

export const Bullet = styled.div`
  ${({ color }) =>
    color === 'yellow'
      ? tw`bg-gold-500`
      : color === 'blue'
      ? tw`bg-carolina-500`
      : tw`bg-gray-500`}
  ${tw`rounded-full w-4 h-4 mt-1.5`}
`

export const BulletText = styled.p`
  ${tw`text-white`}
`
